// app/javascript/controllers/toast_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 5000 }
  }

  connect() {
    // Toast starts visible (translate-x-0) — the old "slide in from
    // translate-x-full via requestAnimationFrame" pattern was racy on
    // Turbo navigations and left toasts stranded off-screen. See
    // _flash_messages.html.erb for the full context. Dismiss animation
    // still slides out cleanly via the class swap in dismiss().
    this.dismissTimeout = setTimeout(() => {
      this.dismiss()
    }, this.durationValue)
  }

  disconnect() {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
    }
  }

  dismiss(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    // Slide out animation
    this.element.classList.remove("translate-x-0")
    this.element.classList.add("translate-x-full")

    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
